import gb from './en-GB';

export const messages = {
  'en-GB': gb,
};
